import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { FormField } from 'ui/formField';
import { DESTINATION_FORM_FIELD_PATHS } from 'modules/sendingPlatforms/contexts';
import { ConnectedInputField } from '../../Shared/ConnectedInputField';
import { CustomHeadersFields } from '../../Shared/CustomHeadersFields';

const { NAME, API_ENDPOINT, CLIENT_ID, CLIENT_SECRET, TOKEN_ENDPOINT, CUSTOM_HEADERS } =
  DESTINATION_FORM_FIELD_PATHS;

const GreyContainer = styled.div`
  background-color: ${colors.grey1};
  border-radius: ${spacing.half};
  padding: ${spacing.base};
  margin-bottom: ${spacing.base};
`;

const TwoColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${spacing.base};
  margin-bottom: ${spacing.base};
`;

export const DestinationFormSection = () => {
  return (
    <div>
      <ConnectedInputField name={NAME} labelText="Name" />
      <ConnectedInputField name={API_ENDPOINT} labelText="Endpoint" />
      <FormField labelText="OAuth 2.0">
        <GreyContainer>
          <TwoColumns>
            <ConnectedInputField name={CLIENT_ID} labelText="Client ID" />
            <ConnectedInputField
              name={CLIENT_SECRET}
              labelText="Client Secret"
              formFieldProps={{ style: { marginTop: 0 } }}
            />
          </TwoColumns>
          <ConnectedInputField name={TOKEN_ENDPOINT} labelText="Token URL" />
        </GreyContainer>
        <CustomHeadersFields name={CUSTOM_HEADERS} />
      </FormField>
    </div>
  );
};
